module.exports = __webpack_public_path__ + "static/media/reply.c5d56539.svg";